// Agent persona + behavior toggles.
import React from 'react';
import {
  ListField, SelectField, SwitchField, TextField,
} from './fields';
import { AGENT_TONES } from './constants';

export default function AgentBehaviorSection({ value, onChange }) {
  const set = (key) => (v) => onChange({ ...value, [key]: v });
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <TextField label="Persona name" value={value.persona_name} onChange={set('persona_name')} />
        <TextField label="Voice label" value={value.voice_label} onChange={set('voice_label')} />
        <SelectField
          label="Tone"
          value={value.tone}
          onChange={set('tone')}
          options={AGENT_TONES}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <SwitchField
          label="Try to save not-interested callers"
          value={value.try_save_not_interested}
          onChange={set('try_save_not_interested')}
        />
        <SwitchField label="Ask for trade-in" value={value.ask_for_trade} onChange={set('ask_for_trade')} />
        <SwitchField label="Push appointment" value={value.push_appointment} onChange={set('push_appointment')} />
        <SwitchField label="Push callback" value={value.push_callback} onChange={set('push_callback')} />
        <SwitchField label="Upsell other products" value={value.upsell_other_products} onChange={set('upsell_other_products')} />
      </div>
      <ListField
        label="Allowed promos"
        value={value.allowed_promos}
        onChange={set('allowed_promos')}
        placeholder="Spring Sale, Loyalty Bonus"
      />
      <ListField
        label="Restricted claims"
        value={value.restricted_claims}
        onChange={set('restricted_claims')}
        placeholder="no-credit-check, guaranteed-approval"
      />
    </div>
  );
}
